export default "__VITE_ASSET__Bgs4CNP___"